import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../PAcido";
import { plotBackground } from "../../../config/colors";


export default function Lecho2PAS() {
  const [temperaturaEntrada, setTemperaturaEntrada] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [temperaturaSalida, setTemperaturaSalida] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caidaPresion, setCaidaPresion] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 5,
    secuencia: 23,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateTemperaturaEntrada(data);
    populateTemperaturaSalida(data);
    populateCaidaPresion(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTemperaturaEntrada(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Entrada Lecho 2 PAS"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTemperaturaEntrada({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTemperaturaSalida(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Lecho 2 PAS"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTemperaturaSalida({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaidaPresion(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caída Presión Lecho 2 PAS"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaidaPresion({
      fecha: arrFechas,
      value: arrValues,
    });
  }
  
 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Lecho 2 PAS"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Temperatura Entrada Lecho 2 PAS --------------------------------------- */}
            <Chart.Line
              name="Temperatura Entrada Lecho 2 PAS"
              data={temperaturaEntrada.value}
              yAxis={0}
            />
            {/** -------------------------------- Temperatura Salida Lecho 2 PAS --------------------------------------- */}
            <Chart.Line
              name="Temperatura Salida Lecho 2 PAS"
              data={temperaturaSalida.value}
              yAxis={0}
            />
            {/** -------------------------------- Caída Presión Lecho 2 PAS --------------------------------------- */}
            <Chart.Line
              name="Caída Presión Lecho 2 PAS"
              data={caidaPresion.value}
              yAxis={1}
            />
           
            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={temperaturaEntrada.fecha} />

            <Chart.YAxis
              labelSuffix=" °C"
              title="Temperatura, °C"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" kPa"
              title="Caída de Presión, kPa"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={5}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
